import { call, put, takeLatest } from 'redux-saga/effects'

import * as loyaltyRepository from 'scripts/api/loyalty'

import history from 'lmcv/routes/history'
import * as service from 'lmcv/services/profile'
import { Constants as CouponContants } from 'lmcv/redux/modules/coupon'

import { Constants, Actions } from '.'

function * getProfile () {
  try {
    const user = yield call(service.getProfileLoyalty)

    yield put(Actions.getSuccess(user))
  } catch (e) {
    yield put(Actions.getFailure(e))
    yield call(history.push, '/fidelidade/faca-parte')
  }
}

function * updateProfile () {
  try {
    const user = yield call(service.getProfileLoyalty)

    yield put(Actions.getSuccess(user))
  } catch (e) {
    yield put(Actions.getFailure(e))

    window.location.reload()
  }
}

function * setProfilePreferences ({ payload }) { // mudar nome
  try {
    yield call(loyaltyRepository.setProfilePreferences, payload)

    yield put(Actions.setProfilePreferencesSuccess())
  } catch (e) {
    yield put(Actions.setProfilePreferencesFailure(e))
  }
}

export default function * root () {
  yield takeLatest(Constants.USER_GET, getProfile)
  yield takeLatest(CouponContants.COUPON_ACTIVE_SUCCESS, updateProfile)
  yield takeLatest(Constants.USER_SET_PROFILE_PREFERENCES, setProfilePreferences)
}
